import Link from 'next/link'
import PropTypes from 'prop-types'
import { Badge, H4, P2 } from '@moneymade/moneymade-ui'

import { ROUTES } from 'static/menusConstants'
import styles from './CollectionColorCard.module.scss'

const CollectionColorCard = ({ collection: { slug, image, title, background, description, matchTags } }) => (
  <Link href={`/${ROUTES.collections}/${slug}`}>
    <a className={styles.CollectionColorCard} style={{ backgroundColor: background || '#e2232a' }} rel="noreferrer">
      <div className={styles.Image}>
        <img src={image} alt={title} />
      </div>

      <div className={styles.Data}>
        <H4 weight="bold" type="heading">
          {title}
        </H4>
        <P2 weight="light">{description}</P2>

        {matchTags && (
          <div className={styles.Tags}>
            {matchTags.map((tag, index) => (
              <Badge key={`tag-${index}`} shape="rounded" size="sm" style={{ color: background }}>
                {tag}
              </Badge>
            ))}
          </div>
        )}
      </div>
    </a>
  </Link>
)

CollectionColorCard.propTypes = {
  collection: PropTypes.shape({
    slug: PropTypes.string,
    image: PropTypes.string,
    title: PropTypes.string,
    background: PropTypes.string,
    description: PropTypes.string,
    matchTags: PropTypes.arrayOf(PropTypes.string)
  })
}

CollectionColorCard.defaultProps = {
  collection: {
    slug: '',
    image: '',
    title: '',
    background: '',
    description: '',
    matchTags: []
  }
}

export default CollectionColorCard
